import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import LightBox from '@bd/bdui-lightbox';
import { colors, typography } from '../../../styles';

const styles = css`
  .HomeContent {
    overflow: hidden;
    padding: 30px 0;
    position: relative;
    @media (min-width: 992px) {
      padding: 120px 0;
      background-image: url('/images/pattern-02-light.svg');
      background-position: center center;
      background-size: cover;
      &::after {
        content: '';
        position: absolute;
        z-index: -1;
        width: 100vw;
        height: 500px;
        right: 0;
        top: -420px;
        background-color: ${colors.brand3};
        transform: skewY(11deg);
        opacity: .3;
      }
    }
  }
  .HomeContent_content {

  }
  .HomeContent_headline {
    font-size: 36px;
    font-family: ${typography.Serif};
    margin: 40px 0;
    line-height: 1;
    color: ${colors.brand1};
    text-align: center;
    @media (min-width: 992px) {
      font-size: 48px;
    }
    @media (min-width: 992px) {
      font-size: 90px;
      text-align: left;
    }
  }
  .HomeContent_subheadline {
    font-weight: normal;
    display: block;
    font-size: 24px;
    color: ${colors.brand2};
    margin: 20px 0;
    line-height: 1;
    @media (min-width: 992px) {
      font-size: 36px;
    }
    @media (min-width: 992px) {
      font-size: 48px;
    }
  }
  .HomeContent_body p {
    font-size: 21px;
    line-height: 1.5;
    font-weight: 200;
    font-family: ${typography.Condensed};
    margin: 0 10px;
    @media (min-width: 992px) {
      font-size: 27px;
      margin: 0;
    }
  }
  .HomeContent_media {
    position: relative;
    height: 260px;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    margin: 0 0 30px 0;
    margin: 0 10px;
    @media (min-width: 992px) {
      height: 100%;
      min-height: 300px;
      margin: 0;
      padding: 0;
    }
  }
  .HomeContent_videoButton {
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-image: url('/images/icon-play-button-white.svg');
      background-position: center center;
      background-size: 70px 70px;
      background-repeat: no-repeat;
      display: block;
      z-index: 2;
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      background-color: ${colors.black};
      opacity: .1;
    }
  }
`;

const videoCss = css`
  margin: 10vh auto 0;
  @media (min-width: 992px) {
    width: 75vw;
    margin: 10vh auto 0;
  }
`;

function HomeContent({ content }) {
  return (
    <div className={styles}>
      <div className="HomeContent">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 ml-lg-auto order-lg-2">
              <div className="HomeContent_media" style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image.contentUrl'), { width: 800, height: 800 })})` }}>
                {
                  get(content, '[0].video') &&
                  <div
                    className="HomeContent_videoButton"
                    role="button"
                    tabIndex="0"
                  >
                    <LightBox
                      enableZoom
                      items={[
                        {
                          element: (
                            <div
                              className={`${videoCss} embed-responsive embed-responsive-16by9`}
                              dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].video'))}
                            />
                          ),
                        },
                      ]}
                    >
                      <span className="HomeContent_videoButton" />
                    </LightBox>
                  </div>
                }
              </div>
            </div>
            <div className="col-lg-6 order-lg-1">
              <div className="HomeContent_content">
                <h1 className="HomeContent_headline">
                  {get(content, '[0].title')}&nbsp;<br />
                  <span className="HomeContent_subheadline">{get(content, '[0].post_title')}</span>
                </h1>
                <div className="HomeContent_body" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].body'))} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HomeContent.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

HomeContent.defaultProps = {
};

export const sectionName = 'Home Conent';

export default HomeContent;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/HomeContent.section.js